export const GET_VAGUES = "store/barometre/GET_VAGUES";
export const GET_VAGUES_COMPLETED = "store/barometre/GET_VAGUES_COMPLETED";
export const GET_VAGUES_FAILED = "store/barometre/GET_VAGUES_FAILED";

export const GET_DETAIL = "store/barometre/GET_DETAIL";
export const GET_DETAIL_COMPLETED = "store/barometre/GET_DETAIL_COMPLETED";
export const GET_DETAIL_FAILED = "store/barometre/GET_DETAIL_FAILED";

export const CLASSIFY = "store/barometre/CLASSIFY";
export const CLASSIFY_COMPLETED = "store/barometre/CLASSIFY_COMPLETED";
export const CLASSIFY_FAILED = "store/barometre/CLASSIFY_FAILED";

export const UPDATE_ITEM = "store/barometre/UPDATE_ITEM";
export const UPDATE_ITEM_COMPLETED = "store/barometre/UPDATE_ITEM_COMPLETED";
export const UPDATE_ITEM_FAILED = "store/barometre/UPDATE_ITEM_FAILED";

export const UPDATE_REPONSE = "store/barometre/UPDATE_REPONSE";
export const UPDATE_REPONSE_COMPLETED = "store/barometre/UPDATE_REPONSE_COMPLETED";
export const UPDATE_REPONSE_FAILED = "store/barometre/UPDATE_REPONSE_FAILED";

export const CREATE_THEME = "store/barometre/CREATE_THEME";
export const CREATE_THEME_COMPLETED = "store/barometre/CREATE_THEME_COMPLETED";
export const CREATE_THEME_FAILED = "store/barometre/CREATE_THEME_FAILED";

export const UPDATE_THEME = "store/barometre/UPDATE_THEME";
export const UPDATE_THEME_COMPLETED = "store/barometre/UPDATE_THEME_COMPLETED";
export const UPDATE_THEME_FAILED = "store/barometre/UPDATE_THEME_FAILED";

export const DELETE_THEME = "store/barometre/DELETE_THEME";
export const DELETE_THEME_COMPLETED = "store/barometre/DELETE_THEME_COMPLETED";
export const DELETE_THEME_FAILED = "store/barometre/DELETE_THEME_FAILED";

export const VALIDATE_VAGUE = "store/barometre/VALIDATE_VAGUE";
export const VALIDATE_VAGUE_COMPLETED = "store/barometre/VALIDATE_VAGUE_COMPLETED";
export const VALIDATE_VAGUE_FAILED = "store/barometre/VALIDATE_VAGUE_FAILED";

export const SAVE_EFFECTIF = "store/barometre/SAVE_EFFECTIF";
export const SAVE_EFFECTIF_COMPLETED = "store/barometre/SAVE_EFFECTIF_COMPLETED";
export const SAVE_EFFECTIF_FAILED = "store/barometre/SAVE_EFFECTIF_FAILED";

export const GET_SYNTHESE = "store/barometre/GET_SYNTHESE";
export const GET_SYNTHESE_COMPLETED = "store/barometre/GET_SYNTHESE_COMPLETED";
export const GET_SYNTHESE_FAILED = "store/barometre/GET_SYNTHESE_FAILED";

export const GET_HISTORY = "store/barometre/GET_HISTORY";
export const GET_HISTORY_COMPLETED = "store/barometre/GET_HISTORY_COMPLETED";
export const GET_HISTORY_FAILED = "store/barometre/GET_HISTORY_FAILED";

export const DELETE_VAGUE = "store/barometre/DELETE_VAGUE";
export const DELETE_VAGUE_COMPLETED = "store/barometre/DELETE_VAGUE_COMPLETED";
export const DELETE_VAGUE_FAILED = "store/barometre/DELETE_VAGUE_FAILED";

export const GET_EMPLOYES = "store/barometre/GET_EMPLOYES";
export const GET_EMPLOYES_COMPLETED = "store/barometre/GET_EMPLOYES_COMPLETED";
export const GET_EMPLOYES_FAILED = "store/barometre/GET_EMPLOYES_FAILED";

export const CREATE_EMPLOYE = "store/barometre/CREATE_EMPLOYE";
export const CREATE_EMPLOYE_COMPLETED = "store/barometre/CREATE_EMPLOYE_COMPLETED";
export const CREATE_EMPLOYE_FAILED = "store/barometre/CREATE_EMPLOYE_FAILED";

export const UPDATE_EMPLOYE = "store/barometre/UPDATE_EMPLOYE";
export const UPDATE_EMPLOYE_COMPLETED = "store/barometre/UPDATE_EMPLOYE_COMPLETED";
export const UPDATE_EMPLOYE_FAILED = "store/barometre/UPDATE_EMPLOYE_FAILED";

export const DELETE_EMPLOYE = "store/barometre/DELETE_EMPLOYE";
export const DELETE_EMPLOYE_COMPLETED = "store/barometre/DELETE_EMPLOYE_COMPLETED";
export const DELETE_EMPLOYE_FAILED = "store/barometre/DELETE_EMPLOYE_FAILED";

export const IMPORT_EMPLOYES = "store/barometre/IMPORT_EMPLOYES";
export const IMPORT_EMPLOYES_COMPLETED = "store/barometre/IMPORT_EMPLOYES_COMPLETED";
export const IMPORT_EMPLOYES_FAILED = "store/barometre/IMPORT_EMPLOYES_FAILED";

export const APPLY_EMPLOYES = "store/barometre/APPLY_EMPLOYES";
export const APPLY_EMPLOYES_COMPLETED = "store/barometre/APPLY_EMPLOYES_COMPLETED";
export const APPLY_EMPLOYES_FAILED = "store/barometre/APPLY_EMPLOYES_FAILED";
